import type { MyAppsCatalogItem, MyAppsExternalApp, MyAppsState } from './myApps';

function asString(value: unknown, fallback = ''): string {
  return typeof value === 'string' ? value : fallback;
}

function asStringList(value: unknown): string[] {
  return Array.isArray(value) ? value.filter((item): item is string => typeof item === 'string') : [];
}

export function asExternalApp(raw: unknown): MyAppsExternalApp | null {
  if (!raw || typeof raw !== 'object') return null;
  const row = raw as Record<string, unknown>;
  const id = asString(row.id || row.Id).trim();
  if (!id) return null;
  return {
    id,
    title: asString(row.title ?? row.Title, id),
    description: asString(row.description ?? row.Description),
    category: asString(row.category ?? row.Category, 'Utilities'),
    icon: asString(row.icon ?? row.Icon),
    path: asString(row.path ?? row.Path, `/apps/link/${encodeURIComponent(id)}`),
    url: asString(row.url ?? row.Url),
    kind: asString(row.kind ?? row.Kind, 'link')
  };
}

export function asMyAppsState(raw: unknown): MyAppsState {
  const row = raw && typeof raw === 'object' ? (raw as Record<string, unknown>) : {};
  const catalogRaw = row.catalog ?? row.Catalog;
  const externalRaw = row.externalApps ?? row.ExternalApps;
  return {
    catalog: Array.isArray(catalogRaw) ? (catalogRaw as MyAppsCatalogItem[]) : [],
    enabledAppIds: asStringList(row.enabledAppIds ?? row.EnabledAppIds),
    pinnedToolIds: asStringList(row.pinnedToolIds ?? row.PinnedToolIds),
    recentToolIds: asStringList(row.recentToolIds ?? row.RecentToolIds),
    externalApps: Array.isArray(externalRaw)
      ? externalRaw.flatMap((item) => {
          const app = asExternalApp(item);
          return app ? [app] : [];
        })
      : []
  };
}
